import { useLabelManagementContext } from '@aibees/elephant/components/search-table-action-dialog-lists/context';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Badge, Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { IconWithCounterProps as Props } from './types';

export const IconWithCounter = memo(
  ({ className, iconName, count, onClick }: Props) => {
    const { labels } = useLabelManagementContext();

    // ! the labels data from the context is not specific to the current item !
    // const number = !!count && count > 0 ? count : labels?.length;0
    const number = !!count && count > 0 ? count : undefined;

    return (
      <Styled.Wrapper
        className={classnames('IconWithCounter', className)}
        sx={SX.root}
        onClick={onClick}
      >
        <Button
          variant="outlined"
          size="small"
          endIcon={<Icon name="plus" color="grey.700" />}
        >
          {!!number && number > 0 ? (
            <Badge
              badgeContent={number > 10 ? '10+' : number}
              color="success"
              sx={SX.cursor}
            >
              <Icon name={iconName} size={18} />
            </Badge>
          ) : (
            <Icon name={iconName} size={18} color="grey.700" />
          )}
        </Button>
      </Styled.Wrapper>
    );
  }
);

IconWithCounter.displayName = 'IconWithCounter';
